import axios from 'axios';

import {
  storeData as _storeData,
} from 'services/CommonService';

import { snackDefaultConfig } from 'utils/global';

const EXPIRATION_TIME = 60 * 60 * 1000;

const VALIDATION_SERVER_URL = process.env.REACT_APP_VALIDATION_SERVER_URL;
const VALIDATION_SERVER_API_KEY =
  process.env.REACT_APP_VALIDATION_SERVER_API_KEY;

const HEADLESS_CMS_API_URL = "/api/cms";

export const getStoredData = (key) => {
  const storedData = localStorage.getItem(key);
  if (storedData) {
    const parsedData = JSON.parse(storedData);
    const currentTime = new Date().getTime();

    if (currentTime - parsedData.timestamp < EXPIRATION_TIME) {
      return parsedData.data;
    }
  }

  return null;
};

const storeData = (key, data) => {
  localStorage.setItem(
    key,
    JSON.stringify({
      data,
      timestamp: new Date().getTime(),
    }),
  );
};

export const fetchStatsData = async () => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Api-Key ${VALIDATION_SERVER_API_KEY}`,
    };
    const response = await axios.get(
      `${VALIDATION_SERVER_URL}/get_stats_data/`,
      {
        headers,
      },
    );

    storeData('stats-data', response.data);

    return response.data;
  } catch (error) {
    console.error('Error: Getting stats data API', error);
    // throw error;
  }
};

export const fetchNewsData = async () => {
  try {
    const response = await axios.get(`${HEADLESS_CMS_API_URL}/posts?status=publish&tags_exclude=313,314,645,655,664&per_page=1`);
    
    const article = Array.isArray(response.data) ? response.data[0] ?? null : null;
    if (article) _storeData('latest-news', article);
    return article;
  } catch (error) {
    console.error('Error: Getting news data API', error);
    return null;
  }
};

export const errorHandler = (err, fnSnackbar, excepts = []) => {
  let message = "";
  
  if (err.status === 403 && !excepts.includes(err.status)) {
    message = 'Authentication credentials were not provided.';
  } else if (err.status === 429 && !excepts.includes(err.status)) {
    message = 'You have exceeded the rate limit. Please try again later.';
  } else if (err.status === 500 && !excepts.includes(err.status)) {
    message = 'A fatal error occurred while searching. Please try again later.';
  }

  if (message) {
    fnSnackbar(message, {
      variant: 'error',
      ...snackDefaultConfig
    });
  }
  
}
